import { z } from 'zod';

export const queueStatsSchema = z.object({
  total: z.number(),
  pending: z.number(),
  active: z.number(),
  completed: z.number(),
  failed: z.number(),
  byStatus: z.record(z.string(), z.number()),
});

export type IQueueStats = z.infer<typeof queueStatsSchema>;
